<template>
    <iframe
        v-if="hasCoordinates"
        class="map-preview"
        :src="mapSrc"
        frameborder="0"
    />
    <div v-else class="no-map-preview">
        <v-icon large>
            mdi-map-marker-off
        </v-icon>
    </div>
</template>

<script>


export default {
    name: 'MapPreview',
    props: {
        apiKey: {
            type: String,
            default: null
        },
        latitude: {
            type: Number,
            default: null
        },
        longitude: {
            type: Number,
            default: null
        },
        height: {
            type: Number,
            default: 450
        }
    },
    computed: {
        hasCoordinates() {
            return !!(this.latitude && this.longitude)
        },
        mapSrc() {
            return `https://www.google.com/maps/embed/v1/place?key=${this.apiKey}&q=${this.latitude},${this.longitude}&zoom=18&language=pl`
        }
    }
}
</script>

<style lang="scss">
    @import '~vuetify/src/components/VToolbar/_variables.scss';

    .map-preview {
        display: block;
        border: 0;
        width: 100%;
        height: calc(100% - #{$toolbar-btn-icon-size});
    }

    .no-map-preview {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: calc(100% - #{$toolbar-btn-icon-size});
        background-color: #eee;
    }
</style>